import styles from './file.module.css'

import React, { useEffect, useRef, useState } from 'react'
import { useUserStore } from '../../store/userStore'
import { deleteFileApi, getFileListApi, uploadFilesApi } from '../../api/file'
import { swalAlert, swalConfirm, swalErrorAlert } from '../../utils/swal/swal'
import { FaFileDownload } from 'react-icons/fa'
import { FaTrashCan } from 'react-icons/fa6'

const FileManage = ({ type }) => {
    // type = 'counsel' || 'schoolRecord'

    /* User Info */
    const { userInfo } = useUserStore(state => state)
    const userId = userInfo?.user_id

    /* file List */
    const [fileList, setFileList] = useState([]) // 업로드된 파일 리스트

    /* file Upload */
    const inputRef = useRef();
    const [isDragging, setIsDragging] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);

    /* useEffect */
    useEffect(() => {
        if (userId && type) {
            getFileList(userId, type)
        }
        else {
            setFileList([])
        }
    }, [userId, type])


    /* Methods */
    const getFileList = async (userId) => {
        try {
            const response = await getFileListApi(userId, type)
            const fileListData = response?.data?.resData ? response?.data?.resData : []

            setFileList(fileListData)
            return

        } catch (error) {
            console.error('파일리스트 조회 실패:', error);
            swalErrorAlert('파일리스트 조회 실패', '파일리스트 조회 중 오류가 발생했습니다.')
            return
        }

    }

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            setSelectedFiles(prevFiles => [...prevFiles, ...e.dataTransfer.files]) // 업로드할 파일에 추가
        }
    };

    const onChangeFileInput = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedFiles(prevFiles => [...prevFiles, ...e.target.files]) // 업로드할 파일에 추가
        }
    };

    const onClickDelete = (idx) => {
        setSelectedFiles((prev) => prev.filter((item, index) => index != idx))
    }

    const onClickDeleteSavedFile = (fileId, fileKey) => {
        if (!fileId || !fileKey) return
        swalConfirm('파일 삭제', '파일을 삭제하시겠습니까?', 'question', '삭제', '취소',
            async () => {
                try {
                    await deleteFileApi(fileId, fileKey)
                    setFileList(prev => prev.filter(file => file.file_id != fileId))
                    swalAlert('파일 삭제 성공', '파일을 성공적으로 삭제했습니다.', 'success', '확인')
                    return

                } catch (error) {
                    console.error('파일 삭제 실패:', error);
                    swalErrorAlert('파일 삭제 실패', '파일 삭제 중 오류가 발생했습니다.')
                    return

                }
            },
            () => { return }
        )

    }

    const onSubmitFileForm = async (type) => {
        if (!type) {
            alert('타입이 지정되지 않았습니다')
            return
        }

        if (selectedFiles.length === 0) {
            alert('업로드할 파일이 없습니다.');
            return;
        }

        const formData = new FormData();
        selectedFiles.forEach(file => formData.append('fileData', file));
        formData.append('type', type)

        try {
            const response = await uploadFilesApi(formData, userId)
            const addedFile = response?.data?.resData // []

            if (addedFile) setFileList(prev => [...prev, ...addedFile])

            swalAlert('업로드 성공', '파일 업로드를 완료했습니다', 'success', '확인')
            setSelectedFiles([]); // 초기화
            inputRef.current.value = ''

        } catch (err) {
            console.error('업로드 실패:', err);
            swalErrorAlert('업로드 실패', '업로드 중 오류가 발생했습니다.')
        }
    }

    return (
        <>
            <div className={styles.fileList}>
                <h5 className='mb-3'>파일리스트</h5>

                {/* 저장된 파일 리스트 */}
                {fileList.length > 0 ? (
                    <ul className="list-group">
                        {fileList.map((file, idx) => (
                            <li className="list-group-item" key={idx}>
                                <a href={file.file_url} download> <FaFileDownload size={"16px"} /> {file.original_name} </a>
                                <button type='button' className='btn text-danger' onClick={() => onClickDeleteSavedFile(file.file_id, file.s3_key)}><FaTrashCan size={"16px"} /></button>
                            </li>
                        ))}
                    </ul>
                ) :
                    <ul className="list-group"><div className='d-flex justify-content-center align-items-center h-100'>저장된 파일이 없습니다.</div></ul>
                }
            </div>

            <div className={styles.fileUpload}>
                <h5 className='mb-3'>파일업로드</h5>

                {/* 파일업로드 input & dnd */}
                <div
                    className={`border ${styles.fileUploadBox} ${isDragging ? styles.dragOver : ''}`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={() => inputRef.current.click()}
                    style={{ cursor: 'pointer' }}
                >
                    <p className="text-muted">이 영역에 파일을 드래그하거나 클릭해서 파일을 선택한 후 업로드 버튼을 눌러주세요</p>
                    <input
                        type="file"
                        multiple
                        ref={inputRef}
                        onChange={onChangeFileInput}
                        style={{ display: 'none' }}
                    />
                </div>

                {/* 선택한 파일 리스트 */}
                {selectedFiles.length > 0 && (
                    <ul className="list-group">
                        {selectedFiles.map((file, idx) => (
                            <li className="list-group-item" key={idx}>
                                {file.name}

                                <button type='button' className='btn text-danger' onClick={() => onClickDelete(idx)}>X</button>
                            </li>
                        ))}
                    </ul>
                )}

                {/* 업로드 버튼 */}
                <div className='mt-3 text-center'>
                    <button type='button' className='btn btn-primary' onClick={() => onSubmitFileForm(type)}>파일 업로드</button>
                </div>
            </div>
        </>

    )
}

export default FileManage